export enum CookieName {

    AcceptCookie = "acceptCookie",
}
